export enum AccountFormFields {
  ArtistName = 'artist_name',
  BankAccount = 'bank_account',
  ContactEmail = 'contact_email',
  ContactName = 'contact_name',
  ContactPhone = 'contact_phone',
  DisplayName = 'display_name',
  Email = 'email',
  Occupation = 'occupation',
  Password = 'password',
  PasswordConfirmation = 'password_confirmation',
  Phone = 'phone',
  RegisterGoal = 'registration_goal',
  UserName = 'username',
  TermsAndConditions = 'terms_and_conditions',
  CeoAddress = 'ceo_address[address_1]',
  CeoCountry = 'ceo_address[country]',
  CeoState = 'ceo_address[state]',
  CeoCity = 'ceo_address[city]',
  CeoPostCode = 'ceo_address[postcode]',
  PromotionalEmails = 'promotional_emails'
}
